import { Component, Input, OnInit } from '@angular/core'
import { Dictionary } from '../../../../types/dictionary.type';

export type OrderMarkersItems = 'distance'
  | 'trailer'
  | 'profit'
  | 'serviceFee';

@Component({
  selector: 'app-order-markers-common-view',
  templateUrl: './order-markers-common-view.component.html',
  styleUrls: ['./order-markers-common-view.component.scss'],
})
export class OrderMarkersCommonViewComponent implements OnInit {
  @Input() distance: string;
  @Input() trailer: string;
  @Input() profit: string;
  @Input() serviceFee: string;

  @Input() config: Dictionary<OrderMarkersItems, OrderMarkersModel> = {};
  items: OrderMarkersModel[] = [];

  getConfig = (config: Dictionary<OrderMarkersItems, OrderMarkersModel>) => ({
    distance: {
      config: {
        header: 'Distance',
        icon: 'distance-crt',
        getViewValue: value => `${value}mi`,
        isDisplayed: true,
        ...(config.distance && config.distance.config || {}),
      },
    },
    trailer: {
      config: {
        header: 'Trailer',
        icon: 'delivery-car-crt',
        getViewValue: value => value,
        isDisplayed: true,
        ...(config.trailer && config.trailer.config || {}),
      },
    },
    profit: {
      config: {
        header: 'Profit',
        icon: 'profit-crt',
        getViewValue: value => `${value}$`,
        isDisplayed: true,
        ...(config.profit && config.profit.config || {}),
      },
    },
    serviceFee: {
      config: {
        header: 'Service Fee',
        icon: 'service-fee-crt',
        getViewValue: value => `${value}`,
        isDisplayed: true,
        ...(config.serviceFee && config.serviceFee.config || {}),
      },
    },
  })

  ngOnInit() {
    this.config = this.getConfig(this.config);

    this.setValue('distance', this.distance);
    this.setValue('trailer', this.trailer);
    this.setValue('profit', this.profit);
    this.setValue('serviceFee', this.serviceFee);

    this.items = Object.values(this.config).filter(x => x.config.isDisplayed);
  }

  private setValue(item: OrderMarkersItems, value: string) {
    const model = this.config[item];
    model.value = value;
    model.viewValue = model.config.getViewValue(value);
  }
}

export class OrderMarkersModel {
  value?: string;
  viewValue?: string;
  config: OrderMarkersConfiguration;
}

class OrderMarkersConfiguration {
  header: string;
  icon: string;
  isDisplayed: boolean;
  getViewValue: (value: string) => string;
}

